import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { WifiOff } from 'lucide-react';
import { createElement } from 'react';

export function useOnlineStatus() {
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const offlineToastId = useRef<string | number | null>(null);
  const mounted = useRef(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      if (offlineToastId.current !== null) {
        toast.dismiss(offlineToastId.current);
        offlineToastId.current = null;
      }
      if (mounted.current) {
        toast.success('Conexión restaurada');
      }
    };
    const handleOffline = () => {
      setOnline(false);
      offlineToastId.current = toast.warning('Sin conexión — trabajando en modo offline', {
        duration: Infinity,
        icon: createElement(WifiOff, { className: 'h-4 w-4' }),
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    mounted.current = true;

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
